import { useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { selectGlobalState } from "../state-management/selectors";
import Container from "../components/basicComponents/container";
import TextArea from "../components/basicComponents/text-area";
import TextInput from "../components/basicComponents/text-input";
import Button from "../components/basicComponents/button";
import * as Icons from "../assets/SVGs/index";
import { userEdit } from "../state-management/actions/user-actions";
import { setCurrentUserData } from "../state-management/actions/global-state-actions";

import {
    setAlert,
    setAlertContext,
    setAlertSeverity,
} from "../state-management/actions/alerts-actions";

const UserProfile: React.FC = () => {
    const dispatch = useDispatch();
    const { currentUserData, rolesData } = useSelector(selectGlobalState);
    const [editData, setEditData] = useState(currentUserData);
    const [flagEdit, setFlagEdit] = useState(false);
    const fileInputRef = useRef<HTMLInputElement | null>(null);
    const role = rolesData.find(
        (role: any) => role._id === currentUserData.role_id
    ).name;

    const MAX_IMAGE_SIZE = 500;
    const imageMimeType = /image\/(png|jpg|jpeg)/i;

    const handleChange = (e: any) => {
        const { name, value } = e.target;
        setEditData({
            ...editData,
            [name]: value,
        });
    };

    const handleSubmit = async () => {
        try {
            const { _id, role_id, ...cleanData } = editData;
            console.log(role_id);
            const response = await userEdit(_id, cleanData)(dispatch);
            if (response) {
                dispatch(
                    setCurrentUserData({ ...currentUserData, ...cleanData })
                );
                setFlagEdit(false);
                dispatch(setAlert(true));
                dispatch(setAlertSeverity("success"));
                dispatch(setAlertContext(" کاربر مربوطه ویرایش شد"));
            }
        } catch (error) {
            console.log(error);
        }
    };

    const handleUploadImage = async (e: any) => {
        const files = e.target?.files;
        if (!files || files.length === 0) {
            setAlert(true);
            setAlertContext("فایلی انتخاب نشده است");
            setAlertSeverity("error");
            return;
        }

        const imageFile = files[0];
        if (!imageFile.type.match(imageMimeType)) {
            setAlert(true);
            setAlertContext("پسوند فایل مربوطه صحیح نمی باشد");
            setAlertSeverity("error");
            return;
        }
        const reader = new FileReader();
        reader.onload = () => {
            if (reader.readyState === 2) {
                const image: any = new Image();
                image.onload = () => {
                    const canvas = document.createElement("canvas");
                    const scaleFactor = Math.min(
                        MAX_IMAGE_SIZE / image.width,
                        MAX_IMAGE_SIZE / image.height
                    );
                    canvas.width = image.width * scaleFactor;
                    canvas.height = image.height * scaleFactor;
                    const ctx: any = canvas.getContext("2d");
                    ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
                    const resizedImage = canvas.toDataURL("image/jpeg", 0.7);
                    setEditData({
                        ...editData,
                        picture: resizedImage,
                    });
                };
                image.src = reader.result;
            }
        };
        reader.readAsDataURL(imageFile);
    };

    return (
        <div className="flex flex-col items-center w-full">
        <Container header="اطلاعات کاربری شما">
            {/* Image and Upload Button Section */}
            <div className="flex items-center gap-4 mb-4">
            <div className="relative md:w-[200px] md:h-[200px] w-[90px] h-[90px]">
            {editData.picture ? (
                    <img className="absolute top-0 right-0 bottom-0 left-0 w-full h-full object-cover"
                        src={editData.picture}
                        alt="personal_picture"
                        style={{
                            borderRadius: "50%",
                            border: "2px solid white",
                        }}
                    />
                ) : (
                    <Icons.AvatarIcon width={200} />
                )}
            </div>
                <div className="block">
                    <Button
                        disabled={!flagEdit}
                        title="انتخاب کنید"
                        variant="success"
                        onClick={() => fileInputRef.current?.click()}
                        paddingx="10px"
                        paddingy="5px"

                    />
                    <input
                        ref={fileInputRef}
                        type="file"
                        accept="image/*"
                        onChange={handleUploadImage}
                        style={{ display: "none" }}
                    />
                    <p className="mt-3">{`نقش : ${role}`}</p>
                    <p className="mt-3">{`نام کاربری : ${editData.username}`}</p>
                </div>
            </div>
    
            {/* Input Fields (Two per Row) */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 w-full">
                <TextInput
                    disabled={!flagEdit}
                    name="firstname"
                    label="نام"
                    initialValue={editData.firstname || ""}
                    value={editData.firstname}
                    onChange={handleChange}
                />
                <TextInput
                    disabled={!flagEdit}
                    name="lastname"
                    label="نام خانوادگی"
                    initialValue={editData.lastname || ""}
                    value={editData.lastname}
                    onChange={handleChange}
                />
                <TextInput
                    disabled={!flagEdit}
                    name="email"
                    label="ایمیل"
                    initialValue={editData.email || ""}
                    value={editData.email}
                    onChange={handleChange}
                />
                <TextInput
                    disabled={!flagEdit}
                    name="phone"
                    label="شماره تماس"
                    initialValue={currentUserData.phone || ""}
                    value={editData.phone}
                    onChange={handleChange}
                />
            </div>
    
            {/* TextArea Section */}
            <div className="mt-4 w-full">
                <TextArea
                    disabled={!flagEdit}
                    name="description"
                    placeholder="بیوگرافی"
                    value={editData.description}
                    onChange={handleChange}
                    rows={4}
                />
            </div>
    
            {/* Buttons Section */}
            <div className="flex gap-4 mt-6 justify-end w-full">
                {flagEdit && (
                    <Button
                        variant="success"
                        title="ذخیره"
                        onClick={handleSubmit}
                    />
                )}
                <Button
                    backgroundColor="gray"
                    title={flagEdit ? "انصراف" : "ویرایش"}
                    onClick={() => setFlagEdit(!flagEdit)}
                />
            </div>
        </Container>
    </div>
    
    );
};

export default UserProfile;
